var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Empresas y roles")]),
      _vm._v(" "),
      _c("div", { staticClass: "card__controls" }, [
        _c(
          "button",
          {
            staticClass: "btn-success",
            attrs: { type: "button" },
            on: { click: _vm.agregar }
          },
          [_c("i", { staticClass: "fa fa-plus" })]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.modelValue, function(val, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _c("div", { staticClass: "form-field select2" }, [
                          _c(
                            "div",
                            { staticClass: "select2-field" },
                            [
                              _c("v-select", {
                                attrs: {
                                  options: _vm.empresas,
                                  label: "nombre_comercial",
                                  placeholder: "Seleccione...",
                                  id: "empresas"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.inputEmpresa(index)
                                  }
                                },
                                model: {
                                  value: val.selectedEmpresa,
                                  callback: function($$v) {
                                    _vm.$set(val, "selectedEmpresa", $$v)
                                  },
                                  expression: "val.selectedEmpresa"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "empresas" } }, [
                                _vm._v("Empresas")
                              ])
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "form-field select2" }, [
                          _c(
                            "div",
                            { staticClass: "select2-field" },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "descripcion",
                                  options: val.roles,
                                  multiple: "",
                                  id: "roles",
                                  placeholder: "Seleccione..."
                                },
                                on: { input: _vm.inputRoles },
                                model: {
                                  value: val.selectedRoles,
                                  callback: function($$v) {
                                    _vm.$set(val, "selectedRoles", $$v)
                                  },
                                  expression: "val.selectedRoles"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "roles" } }, [
                                _vm._v("Roles")
                              ])
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-danger btn--text",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.eliminar(index)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-trash" })]
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.modelValue.length === 0,
                          expression: "modelValue.length === 0"
                        }
                      ]
                    },
                    [_vm._m(1)]
                  )
                ],
                2
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Empresa")]),
        _vm._v(" "),
        _c("th", [_vm._v("Roles")]),
        _vm._v(" "),
        _c("th", [_vm._v("Acciones")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("strong", [_vm._v("No se ha agregado filas.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d4b864a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d4b864a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/usuarios/TablaUsuarioEmpresa.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0d4b864a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/usuarios/TablaUsuarioEmpresa.vue
// module chunks = 0